import { Injectable, Injector } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BaseService } from '../shared/services/base.service';

@Injectable({
    providedIn: 'root'
})
export class MotorRecomendacaoEquipeService extends BaseService<any> {

    constructor(protected injector: Injector) {
        super(`${environment.API_PRICE}/motorrecomendacaoequipe`, injector);
    }

    gerarEquipe(idEstimativa: number) {
        return this.http.get(`${environment.API_PRICE}/motorrecomendacaoequipe/montarequipe/${idEstimativa}`);
    }
}